import React, { useEffect, useState } from "react";
import "./BidIndex.css";

export function BidTable({
  maxHeight = "calc(-300px + 100vh)",
  mode = "normal",
  data,
}: {
  maxHeight?: string;
  mode?: any;
  data: any[];
}) {
  const [tableData, setTableData] = useState<any[]>([]);

  useEffect(() => {
    setTableData(data);
  }, [data]);
  //  const bids = Array.from(new Set(tableData.map((item) =>  parseInt(item.bid.replace(/\D/g, ""), 10))))

  const bids = Array.from(new Set(tableData.map((item) => item.bid)));
  // const slots = Array.from(
  //   new Set(tableData.map((item) => item.time_slot__slot))
  // );

  interface SlotType {
    time_slot__slot: string; // or number, depending on your data
    time_string: string;
  }

  const slots: SlotType[] = tableData.reduce((acc, item) => {
    const existingSlot = acc.find(
      (slot: { time_slot__slot: any }) =>
        slot.time_slot__slot === item.time_slot__slot
    );
    if (!existingSlot) {
      acc.push({
        time_slot__slot: item.time_slot__slot,
        time_string: item.time_string,
      });
    }
    return acc;
  }, [] as SlotType[]);
  return (
    <>
      {tableData.length === 0 ? (
        <>
          <div
            className=" overflow-auto capitalize text-nowrap rounded-lg"
            style={{ maxHeight }}
          >
            <h1 className="chartHeading !text-2xl text-center !font-medium w-100">
              No Bid Created...
            </h1>
          </div>
        </>
      ) : (
        <>
          <div
            className=" overflow-auto capitalize text-nowrap rounded-lg border border-gray-200"
            style={{ maxHeight }}
          >
            <table id="my-table" className="table-auto bid_table">
              <thead className="sticky top-0 z-50 text-[#F1935C] bg-[#FFF8F4]">
                {/* First header row */}
                <tr>
                  <th
                    rowSpan={2}
                    className="sticky left-0 z-30 border-[#F1935C] px-4 py-2 text-center rounded-tl-xl min-w-[120px] bg-[#FFF8F4]"
                  >
                    Time Block
                  </th>
                  {bids.map((bid, idx) => (
                    <th
                      key={idx}
                      colSpan={2}
                      className={`border border-[#F1935C] text-[#34656D] px-4 py-2 text-center ${
                        bid === "D0"
                          ? "sticky left-[199px] z-20 bg-[#FFF8F4]"
                          : ""
                      }`}
                    >
                      {bid === "D0"
                        ? "Deficit Bid"
                        : tableData.some(
                            (item) => item.bid === bid && item.isBuy
                          )
                        ? `Buy Bid ${bid.replace(/\D/g, "")}`
                        : `Sell Bid ${bid.replace(/\D/g, "")}`}
                    </th>
                  ))}
                </tr>
                {/* Second header row */}
                <tr>
                  {bids.map((bid, idx) => (
                    <React.Fragment key={idx}>
                      <th
                        className={`border border-[#F1935C] px-4 py-2 text-center min-w-[100px] ${
                          bid === "D0"
                            ? "sticky left-[199px] z-20 bg-[#FFF8F4]"
                            : ""
                        }`}
                      >
                        Quantum
                      </th>
                      <th
                        className={`border border-[#F1935C] px-4 py-2 text-center min-w-[100px] ${
                          bid === "D0"
                            ? "sticky left-[299px] z-20 bg-[#FFF8F4]"
                            : ""
                        }`}
                      >
                        Rate
                      </th>
                    </React.Fragment>
                  ))}
                </tr>
              </thead>

              <tbody className="text-[#8C8A96] font-normal text-[13px]">
                {slots.map((slot, rowIdx) => (
                  <tr
                    key={rowIdx}
                    className="border-b border-gray-200 hover:bg-gray-100 text-center"
                  >
                    {/* Time Block cell */}
                    <td className="sticky left-0 z-10 min-w-[100px] bg-white py-3 px-4 !border-r !border-[#F1935C]">
                      Slot {slot.time_slot__slot}: ({slot.time_string})
                    </td>

                    {/* Data cells for each bid */}
                    {bids.map((bid, colIdx) => {
                      const record = tableData.find(
                        (r) => r.time_slot__slot === slot.time_slot__slot && r.bid === bid
                      );
                      return (
                        <React.Fragment key={colIdx}>
                          <td
                            className={`${
                              colIdx % 2 === 0
                                ? "bg-blue-50 py-3 px-2 min-w-[100px]"
                                : "bg-white py-3 px-2 min-w-[100px]"
                            } ${
                              bid === "D0"
                                ? "sticky left-[199px] z-10 bg-white"
                                : ""
                            }`}
                          >
                            {(record?.quantum ?? 0) === 0 ? "-" : record.quantum}
                          </td>
                          <td
                            className={`${
                              colIdx % 2 === 0
                                ? "bg-blue-50 py-3 px-2 min-w-[100px] !border-r !border-[#F1935C]"
                                : "bg-white py-3 px-2 min-w-[100px] !border-r !border-[#F1935C]"
                            } ${
                              bid === "D0"
                                ? "sticky left-[299px] z-10 bg-white"
                                : ""
                            }`}
                          >
                             {(record?.price ?? 0) === 0 ? "-" : record.price}
                          </td>
                        </React.Fragment>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
}
